const appRoutes = {
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  optOutMarketing: '/opt-out-marketing',
  nurseProfile: 'profile',
  changePassword: 'change-password',
  updatePassword: 'update-password',
  logins: 'logins',
  addLogin: 'login/add',
  editLogin: 'login/edit',
  clinics: 'clinics',
  addClinic: 'clinic/add',
  clinicLocations: 'clinic/locations',
  clinicConsentTemplates: 'clinic/consent-templates',
  clinicMedicalHistoryTemplates: 'clinic/medical-history-templates',
  clinicTreamentOptions: 'clinic/clinical-treatment-options',
  clinicStockDetails: 'clinic/stock-details',
  clinicAdditionalSettings: 'clinic/additional-settings',
  addTemplate: 'clinic/template',
  bookings: 'bookings',
  onlineBooking: 'booking',
  bookingConfirmation: 'confirm-booking',
  bankDetails: 'bank-details',
  editBankDetails: 'edit-bank-details',
  addBankDetails: 'add-bank-details',
  editBooking: 'booking/edit',
  createBooking: ':patientId/bookings/create',
  paymentSummary: 'payment-summary',
  viewBooking: 'booking/view',
  patients: 'patients',
  addPatient: 'patient/add',
  practitionerConsents: 'practitioner-consents',
  editPractitionerConsents: 'practitioner-consent/edit',
  stocks: 'injectables-stock',
  addStock: 'injectables-stock/add',
  editStock: 'injectables-stock/edit',
  viewStock: 'injectables-stock/view',
  otherStocks: 'other-stock',
  addOtherStock: 'other-stock/add',
  editOtherStock: 'other-stock/edit',
  viewOtherStock: 'other-stock/view',
  productStocks: 'product-stock',
  addProductStock: 'product-stock/add',
  editProductStock: 'product-stock/edit',
  viewProductStock: 'product-stock/view',
  legal: 'legal',
  marketing: 'marketing',
  marketingReminders: 'marketing/reminders',
  marketingPromotional: 'marketing/promotional',
  marketingUsage: 'marketing/usage',
  editReminder: 'reminder',
  reporting: 'reporting',
  nurseShifts: 'shifts',
  addPayment: 'payment',
  keyPerformance: 'key-performance',
  keyPerformanceActions: 'key-performance-actions',
  keyPerformanceRetention: 'key-performance-actions/client-retention',
  keyPerformanceConversion: 'key-performance-actions/client-conversion',
  prDashboard: '/pr/patient',
  prConsentForms: '/pr/consentForms',
  prMedicalHistory: '/pr/medicalhistory',
  prPractitionerConsents: '/pr/practitionerconsents',
  prEditPractitionerConsents: '/pr/editpractitionerconsents',
  prBookingHistory: '/pr/booking/history',
  prProtocols: '/pr/protocols',
  prViewProtocol: '/pr/protocols/view',
  prAddS4DrugProtocolForm: '/pr/s4-drug-protocols/create',
  // prViewS4DrugProtocol: '/pr/s4-drug-protocols/view',
  prAddOtherProtocol: '/pr/other-protocols/create',
  // prViewOtherProtocol: '/pr/other-protocols/view',
  prEditBookingHistory: '/pr/bookinghistory/edit',
  prCreateBooking: '/pr/:patientId/bookings/create',
  prViewBookingHistory: '/pr/bookinghistory/view',
  prAddNewConsentForm: '/pr/addNewConsentForm',
  prPayment: '/pr/payment',
};

export default appRoutes;
